import { render, staticRenderFns } from "./Menuv2.vue?vue&type=template&id=31449810&scoped=true&"
import script from "./Menuv2.vue?vue&type=script&lang=js&"
export * from "./Menuv2.vue?vue&type=script&lang=js&"
import style0 from "./Menuv2.vue?vue&type=style&index=0&id=31449810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31449810",
  null
  
)

export default component.exports